module.exports = __webpack_public_path__ + "static/media/google-store.eb340894.png";